import { cva } from 'class-variance-authority';

/**
 * Search is `Text Input_Pill` with a fixed glyph and a clear button, so it reads the pill's recipes
 * and the `--ds-input-pill-*` slots unchanged. Every recipe here is an OVERRIDE merged after the
 * pill's own through `cn`, which is `tailwind-merge`: a class below replaces the pill's class in the
 * same group (`px-[12px]` over `px-[20px]`) rather than competing with it.
 *
 * That is deliberate. The Figma set (1993:125669) was cloned from the pill and shares its `#1372:*`
 * keys, tokens and state matrix; only geometry differs. A second copy of the colour rules would be
 * the first thing to drift.
 */

/** The bordered box. Small is 32px tall; Menu squares the pill down to the List-Item radius. */
export const searchBoxRecipe = cva([], {
  variants: {
    size: {
      medium: [],
      small: ['px-[12px]'],
    },
    placement: {
      standalone: [],
      // Raw 10px, the same deliberate one-off List-Item uses, so the field and the rows under it
      // share a corner. The Menu is 16 with 8px padding; a pill (16) would not nest in it.
      menu: ['rounded-[10px]'],
    },
  },
  defaultVariants: { size: 'medium', placement: 'standalone' },
});

/**
 * The control pays the vertical padding, as on the pill, so the whole box stays the click target.
 * Medium: 1 + 10 + 20 + 10 + 1 = 42. Small: 1 + 5 + 20 + 5 + 1 = 32.
 */
export const searchControlRecipe = cva([], {
  variants: {
    size: {
      medium: [],
      small: ['py-[5px]'],
    },
  },
  defaultVariants: { size: 'medium' },
});

/** The 2px inset the Menu placement draws on its variant root, inside the popup's own 8px. */
export const searchRootRecipe = cva([], {
  variants: {
    placement: {
      standalone: [],
      menu: ['p-[2px]'],
    },
  },
  defaultVariants: { placement: 'standalone' },
});

/** Helper text is indented to the glyph, which moves in with Small's padding. */
export const searchHelperRecipe = cva([], {
  variants: {
    size: {
      medium: [],
      small: ['pl-[calc(12px_+_var(--ds-input-pill-border-width))]'],
    },
  },
  defaultVariants: { size: 'medium' },
});
